import { buildContractStatusActions } from "./actions/build-contract-status-actions";
import { downloadContract } from "./actions/download-contract";

import {
  PermissionsAction,
  PermissionsPosModule,
  PermissionsScope
} from "@/common/types/permissions";
import { IStep } from "@/modules/Terms/interfaces/ITerm.interface";

interface IBuildMenu {
  contract: any;
  permissions: any;
  nextStep: IStep;
  setIsVisible: (isVisible: boolean) => void;
  setIsContractOccurrencesDrawerVisible: (
    isContractOccurrencesDrawerVisible: boolean
  ) => void;
  action: string;
  toggleActionModal: () => void;
  setAction: (action: string) => void;
  setActionMessage: (actionMessage: string) => void;
  contractId: string;
  isButtonDisabled?: boolean;
  isDownloadingContract?: boolean;
  setIsDownloadingContract?: (condition: boolean) => void;
}

export const buildMenu = ({
  contract,
  permissions,
  nextStep,
  setIsVisible,
  setIsContractOccurrencesDrawerVisible,
  action,
  toggleActionModal,
  setAction,
  setActionMessage,
  contractId,
  isButtonDisabled,
  isDownloadingContract,
  setIsDownloadingContract
}: IBuildMenu) => {
  const status = buildContractStatusActions({
    contract,
    permissions,
    nextStep,
    isButtonDisabled,
    action,
    toggleActionModal,
    setAction,
    setActionMessage
  });

  const canSendDocuments = contract => {
    if (!contract?.approvalFlow) return false;

    const lastStepToSendDocument = contract.approvalFlow.steps.find(
      step => step.internalName === "SERVICE_DELIVERED"
    );

    return (
      contract.currentStep?.order >= 10 &&
      contract.currentStep?.order <= lastStepToSendDocument?.order
    );
  };

  const menu = [
    {
      id: "button-print",
      key: "Imprimir",
      text: "Imprimir",
      iconProps: {
        iconName: "Print"
      },
      onClick: () => {
        downloadContract(contractId, setIsDownloadingContract);
      },
      disabled: !contract.pdfPath || isDownloadingContract
    },
    {
      id: "button-change-status",
      key: "status",
      text: "Alterar status",
      iconProps: {
        iconName: "Sync"
      },
      subMenuProps: {
        items: status
      },
      disabled: status?.length === 0
    },
    {
      id: "button-attach-documents",
      key: "Anexar Documento(s)",
      text: "Anexar Documento(s)",
      iconProps: {
        iconName: "DocumentSet"
      },
      disabled: !canSendDocuments(contract),
      onClick: () => setIsVisible(true)
    }
  ];

  const canReadContractOccurrences = permissions[PermissionsScope.POS]?.[
    PermissionsPosModule.CONTRACTS
  ]?.some(
    contractAction =>
      contractAction === PermissionsAction.ALL ||
      contractAction === "contract-occurrences"
  );

  const contractHistoryButton = {
    id: "button-contract-history",
    key: "contractOccurrences",
    text: "Histórico do contrato",
    iconProps: {
      iconName: "FullHistory"
    },
    onClick: () => setIsContractOccurrencesDrawerVisible(true),
    disabled: false
  };

  if (canReadContractOccurrences) {
    menu.push(contractHistoryButton);
  }

  return menu;
};
